<ion-content [fullscreen]="true">
  <!-- Back Button -->
  <ion-button fill="clear" class="ion-margin" (click)="modalCtrl.dismiss()">
    <ion-icon name="arrow-back" slot="icon-only" color="medium"></ion-icon>
  </ion-button>

  <!-- Header Section -->
  <div class="header-container ion-padding">
    <h2>Verify Your Code</h2>
    <p>Please enter the 4-digit code sent to your mobile number.</p>
  </div>

  <!-- OTP Input Section -->
  <div class="ion-padding">
    <ng-otp-input [config]="otpConfig" (onInputChange)="onOtpChange($event)" style="justify-content: center;"></ng-otp-input>
  </div>

  <!-- Resend & Verify Buttons -->
  <div class="ion-padding ion-margin-top button-group" align="center">
    <ion-button class="button" expand="block" (click)="verifyOtp()">Verify Code</ion-button>
    <div *ngIf="!isResendDisabled">
      <ion-button fill="clear" color="medium" [disabled]="isResendDisabled" (click)="resendOtp()">Resend Code</ion-button>
    </div>
    <div *ngIf="isResendDisabled">
      <p>Resend SMS in {{ resendCountdown }} seconds</p>
    </div>
  </div>
</ion-content>
